import { get } from 'lodash/fp';
import {
  CMS_KEY as GLOBAL_PROMO_CMS_KEY,
  STORE_KEY as GLOBAL_PROMO_STORE_KEY,
} from './duck';

export {
  reducer as globalPromoReducer,
  cmsDuck as globalPromoCmsDuck,
} from './duck';

export const getGlobalPromoCmsResult = get([
  GLOBAL_PROMO_STORE_KEY,
  GLOBAL_PROMO_CMS_KEY,
  'result',
]);

export { GLOBAL_PROMO_STORE_KEY, GLOBAL_PROMO_CMS_KEY };
